import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { RosterAssignment } from "@app/models/rest/roster/roster-assignment";

@Injectable({
  providedIn: "root"
})
export class RosterAssignmentRestService extends HateoasResourceOperation<RosterAssignment> {
  constructor() {
    super(RosterAssignment);
  }
}
